import { z } from 'zod';
import { DependencyType } from './project.js';
/**
 * Suy ra phụ thuộc còn thiếu — APM-AI-j (`plan-ai-features.md` mục 9).
 *
 * ## Vì sao mỗi đề xuất phải trích một câu
 *
 * Đề xuất phụ thuộc là thứ dễ **thừa** nhất trong cả đợt AI này: nối hai việc
 * bất kỳ luôn nghe có lý ("làm A trước rồi mới B"), và một đồ thị dày đặc cạnh
 * bịa thì đường găng dài ra vì những ràng buộc không tồn tại — kế hoạch trông
 * chặt chẽ mà sai nền.
 *
 * `evidence` là câu **lấy nguyên** từ mô tả hoặc tiêu đề của một trong hai task.
 * Không trích được nghĩa là model đang suy đoán, và `finalize()` loại nó.
 */
export const DependencyProposal = z.object({
    fromTaskId: z.uuid(),
    toTaskId: z.uuid(),
    kind: DependencyType,
    confidence: z.enum(['low', 'medium', 'high']),
    /** Vì sao — một câu, cho người duyệt đọc. */
    reason: z.string().min(1).max(300),
    /** Câu trích nguyên văn từ tiêu đề/mô tả task làm bằng chứng. */
    evidence: z.string().min(3).max(500),
});
export const DependencyProposals = z.object({
    proposals: z.array(DependencyProposal).max(20),
    /**
     * Đề xuất bị loại vì tạo vòng, kèm lý do — UI giải thích được vì sao một cạnh
     * "hợp lý" không xuất hiện, thay vì im lặng bỏ nó.
     */
    cyclesDetected: z
        .array(z.object({ fromTaskId: z.uuid(), toTaskId: z.uuid(), reason: z.string().max(300) }))
        .max(20),
});
//# sourceMappingURL=ai-dependency.js.map